export const pokemonAPI = "https://pokeapi.co/api/v2";
export const pokemonsRoute = `${pokemonAPI}/pokemon?limit=5000`;
export const pokemonRoute = `${pokemonAPI}/pokemon`;
export const pokemonSpeciesRoute = `${pokemonAPI}/pokemon-species`;

export const pokemonTabs = {
  description: "description",
  evolution: "evolution",
  locations: "locations",
  moves: "moves",
};

/*

responsive,
performance,
special type poke,
moves gif,
pokemon yu wala,
search by type,
display type on hover,

*/